// Curated font list for the rich-text editor font dropdown.
// System fonts (marked system: true) are available on all platforms without a
// Google Fonts load. Google Fonts entries mirror backend/utils/fonts.py CURATED_FONTS.

export const CURATED_FONTS = [
  // System fonts — no Google Fonts request needed
  { value: 'Times New Roman', category: 'serif', system: true },
  { value: 'Georgia', category: 'serif', system: true },
  { value: 'Arial', category: 'sans-serif', system: true },
  // Google Fonts
  { value: 'Playfair Display', category: 'serif' },
  { value: 'Manrope', category: 'sans-serif' },
  { value: 'Inter', category: 'sans-serif' },
  { value: 'Poppins', category: 'sans-serif' },
  { value: 'Lora', category: 'serif' },
  { value: 'Merriweather', category: 'serif' },
  { value: 'Montserrat', category: 'sans-serif' },
  { value: 'Roboto', category: 'sans-serif' },
  { value: 'Open Sans', category: 'sans-serif' },
  { value: 'Nunito', category: 'sans-serif' },
  { value: 'Raleway', category: 'sans-serif' },
  { value: 'DM Sans', category: 'sans-serif' },
  { value: 'Source Serif 4', category: 'serif' },
  { value: 'Work Sans', category: 'sans-serif' },
  { value: 'Crimson Text', category: 'serif' },
];

export const DEFAULT_HEADING_FONT = 'Playfair Display';
export const DEFAULT_BODY_FONT = 'Manrope';

export const FONT_SIZES = [12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 48];

// Builds a Google Fonts stylesheet URL for the given font family names.
export function googleFontsHref(fontNames) {
  const families = Array.from(new Set(fontNames.filter(Boolean)))
    .map((name) => `family=${name.trim().replace(/\s+/g, '+')}:wght@400;500;600;700`)
    .join('&');
  return `https://fonts.googleapis.com/css2?${families}&display=swap`;
}
